export const MENUITEMS = [
  {
    menutitle: "General",
    menucontent: "Dashboards,Widgets",
    Items: [
      {
        title: "Dashboard",
        icon: "home",
        badge: "badge badge-light-primary",
        type: "link",
        path: `${process.env.PUBLIC_URL}/dashboard/default`
      },
      {
        title: "Users",
        icon: "user",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/allUsers`
      },
      {
        title: "Vendor",
        icon: "bookmark",
        type: "sub",
        badge: "badge badge-light-secondary",
        active: false,
        children: [
          { path: `${process.env.PUBLIC_URL}/diet_chart`, type: "link", title: "Diet Chart" },
          { path: `${process.env.PUBLIC_URL}/fitness_category`, type: "link", title: "Fitness Category" },
          { path: `${process.env.PUBLIC_URL}/allVendors`, type: "link", title: "Vendor" },
          // { path: `${process.env.PUBLIC_URL}/allClasses`, type: "link", title: "Classes" },
          // { path: `${process.env.PUBLIC_URL}/allVideos`, type: "link", title: "Banner" },
          { path: `${process.env.PUBLIC_URL}/chemist`, type: "link", title: "Chemist" },
          {
            title: "Category",
            type: "sub",
            children: [
              { path: `${process.env.PUBLIC_URL}/Vendors/VideoCategory`, type: "link", title: "Video Category" },
            ]
          }
        ]
      },
      {
        title: "SubAdmin",
        icon: "user",
        type: "sub",
        badge: "badge badge-light-secondary",
        active: false,
        children: [
          { path: `${process.env.PUBLIC_URL}/allRole`, type: "link", title: "Role" },
          { path: `${process.env.PUBLIC_URL}/subAdmin`, type: "link", title: "User" },
          { path: `${process.env.PUBLIC_URL}/permission`, type: "link", title: "Permission" },
          { path: `${process.env.PUBLIC_URL}/assignPermission`, type: "link", title: "Assign" },
        ]
      },
      {
        title: "Medical Reminder",
        icon: "user",
        type: "sub",
        badge: "badge badge-light-secondary",
        active: false,
        children: [
          { path: `${process.env.PUBLIC_URL}/medicine`, type: "link", title: "Medicine" },
          { path: `${process.env.PUBLIC_URL}/doctor`, type: "link", title: "Doctor" },
          { path: `${process.env.PUBLIC_URL}/vacination`, type: "link", title: "Vacination" },
          // { path: `${process.env.PUBLIC_URL}/community`, type: "link", title: "Community" },
        ]
      },
      {
        title: " Community (Social Meet)",
        icon: "user",
        type: "sub",
        badge: "badge badge-light-secondary",
        active: false,
        children: [
          { path: `${process.env.PUBLIC_URL}/community`, type: "link", title: "Community list" },
          { path: `${process.env.PUBLIC_URL}/event`, type: "link", title: "Events" },
          { path: `${process.env.PUBLIC_URL}/categery`, type: "link", title: "Categery" },
          { path: `${process.env.PUBLIC_URL}/distance`, type: "link", title: "Distance" },


        ]
      },
      // {
      //   title: "Alzheimer",
      //   icon: "user",
      //   type: "sub",
      //   badge: "badge badge-light-secondary",
      //   active: false,
      //   children: [
      //     { path: `${process.env.PUBLIC_URL}/assessment`, type: "link", title: "Assessment" },
      //     { path: `${process.env.PUBLIC_URL}/assessment-category`, type: "link", title: "Assessment-category" },
      //     { path: `${process.env.PUBLIC_URL}/videos`, type: "link", title: "Videos" },
      //     { path: `${process.env.PUBLIC_URL}/meditation`, type: "link", title: "Meditation" },
      //     { path: `${process.env.PUBLIC_URL}/task`, type: "link", title: "Task" },
      //     { path: `${process.env.PUBLIC_URL}/activities`, type: "link", title: "Activities" },
      //     { path: `${process.env.PUBLIC_URL}/games`, type: "link", title: "Games" },
      //     { path: `${process.env.PUBLIC_URL}/doctors`, type: "link", title: "Doctors" },
      //   ]
      // },
    ],
  },
  {
    menutitle: "Applications",
    menucontent: "Ready to use Apps",
    Items: [
      {
        title: "Banner",
        icon: "gallery",
        type: "sub",
        badge: "badge badge-light-secondary",
        active: false,
        children: [
          { path: `${process.env.PUBLIC_URL}/banner/home_banner`, type: "link", title: "Home Page Banner" },
          { path: `${process.env.PUBLIC_URL}/banner/fitness_banner`, type: "link", title: "Fitness Banner" },
        ],
      },
      {
        title: "Games",
        icon: "icons",
        badge: "badge badge-light-primary",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/games`
      },
      // {
      //   title: "Social meet",
      //   icon: "social",
      //   type: "sub",
      //   badge: "badge badge-light-secondary",
      //   active: false,
      //   children: [
      //     { path: `${process.env.PUBLIC_URL}/social-meet/event-list`, type: "link", title: "Event list" },
      //   ],
      // },
      
      //  {
      //   title: "Share care",
      //   icon: "blog",
      //   type: "sub",
      //   badge: "badge badge-light-secondary",
      //   active: false,
      //   children: [],
      // },
    ],
  },
];
